export const fontSize = {
  xs: ["0.75rem", { lineHeight: "1rem" }],
  sm: ["0.875rem", { lineHeight: "1.25rem" }],
  base: ["1rem", { lineHeight: "1.5rem" }],
  lg: ["1.125rem", { lineHeight: "1.75rem" }],
  xl: ["1.25rem", { lineHeight: "1.75rem" }],
  "2xl": ["1.5rem", { lineHeight: "2rem" }],
  "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
  "5xl": ["3rem", { lineHeight: "1" }],
} as const;

export const fontSizeValues = Object.fromEntries(
  Object.entries(fontSize).map(([k, [size]]) => [k, size as string]),
) as Record<string, string>;
